module.exports = __webpack_public_path__ + "fonts/SFUIText-Medium.8a0ea0d3.woff2";